import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { KieneAutocompleteModule } from '../../../../projects/kiene-core/src/lib/components/kiene-autocomplete/kiene-autocomplete.module';
import { KieneTableModule } from '../../components/kiene-table/kiene-table.module';
import { FortbildungDialogComponent } from './fortbildung-dialog/fortbildung-dialog.component';
import { FortbildungComponent } from './fortbildung/fortbildung.component';
import { TeilnehmerHinzufuegenDialogComponent } from './teilnehmer-hinzufuegen-dialog/teilnehmer-hinzufuegen-dialog.component';

@NgModule({
    declarations: [FortbildungComponent, FortbildungDialogComponent, TeilnehmerHinzufuegenDialogComponent],
    imports: [
        CommonModule,
        KieneTableModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatDialogModule,
        KieneAutocompleteModule,
        KieneAutocompleteModule,
        MatSelectModule,
        FormsModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatIconModule,
    ],
    exports: [FortbildungComponent],
})
export class FortbildungenModule {}
